import { render, staticRenderFns } from "./CapitalStatistics.vue?vue&type=template&id=413e3e0c&scoped=true"
import script from "./CapitalStatistics.vue?vue&type=script&lang=js"
export * from "./CapitalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e3e0c",
  null
  
)

export default component.exports